<template>
  <Collapse :when="!!show">
    <div v-bind="$attrs" class="grid grid-cols-2 gap-2">
      <LightBlockButton :disabled="saving" @click="$emit('cancel')" :color="cancelColor">
        <i class="icon-x text-lg mr-2" :class="{ 'text-gray-700': cancelColor === 'white' }"></i>
        <span :class="{ 'text-gray-700': cancelColor === 'white' }">Cancel</span>
      </LightBlockButton>
      <PrimaryBlockButton :disabled="disabled || saving" @click="$emit('save')">
        <i class="icon-check text-lg mr-2"></i>
        {{ saving ? savingText : saveText }}
        <IonSpinner v-if="saving" class="ml-2" name="dots" color="white" />
      </PrimaryBlockButton>
    </div>
  </Collapse>
</template>

<script setup lang="ts">
import { Collapse } from 'vue-collapsed';
import LightBlockButton from './LightBlockButton.vue';
import PrimaryBlockButton from './PrimaryBlockButton.vue';
import { IonSpinner } from '@ionic/vue';

withDefaults(
  defineProps<{
    show?: boolean;
    disabled?: boolean;
    saving?: boolean;
    cancelColor?: 'light' | 'white';
    saveText?: string;
    savingText?: string;
  }>(),
  { cancelColor: 'light', saveText: 'Save', savingText: 'Saving' }
);
defineEmits<{
  (e: 'save'): void;
  (e: 'cancel'): void;
}>();
</script>
